<template lang="pug">
div
  .swiper-container
    .swiper-wrapper
      //- .swiper-slide.match-marketgroup-content(:class="(source.marketId == 3) ? 'live' : ''")
      .swiper-slide.match-marketgroup-content.live(:class="leagueKindClassOf(source.leagueId)")
        .match-bet-area-group.flex-grow-2
          hdpItem(:details="details" :oddsType="oddsType" betType="hdp" homeAway="1")
        .match-bet-area-group.flex-grow-2
          ouItem(:details="details" :oddsType="oddsType" betType="ou")
        .match-bet-area-group.flex-grow-1(v-if="source.sportsId != 42")
          mlItem(:details="details" :oddsType="oddsType" betType="ml")
        .match-bet-area-group.flex-grow-1(v-else)
          oeItem(:details="details" :oddsType="oddsType" betType="oe" :sportType="source.sportsId")
</template>

<script>
import hdpItem from "@/components/mobile/main/xitem/hdpItem";
import ouItem from "@/components/mobile/main/xitem/ouItem";
import mlItem from "@/components/mobile/main/xitem/mlItem";
import oeItem from "@/components/mobile/main/xitem/oeItem";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    hdpItem,
    ouItem,
    mlItem,
    oeItem
  },
  mixins: [mixinHDPOUOdds],
  data() {
    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.sw ? this.$refs.sw.$swiper : 0;
    }
  },
  mounted() {
    this.activeIndex = this.swiper.activeIndex;
  },
  methods: {
    handleSlideChange() {
      this.activeIndex = this.swiper.activeIndex;
    }
  }
};
</script>
